module.exports = __webpack_public_path__ + "static/fonts/Nunito-LightItalic.d2b5d76.woff";